// DnD Types and Constants

export const ENTITY_TYPES = {
    COURSE: 'course',
    MODULE: 'module',
    SECTION: 'section',
    CHAPTER: 'chapter',
    LECTURE: 'lecture',
    FILE: 'file',
    FLASHCARD: 'flashcard',
    QBANK: 'qbank'
};

export const SCOPE_TYPES = {
    COURSE: 'course',
    MODULE: 'module',
    SECTION: 'section',
    CHAPTER: 'chapter'
};

export const DRAG_TYPES = {
    SECTION: 'section',
    CHAPTER: 'chapter',
    LECTURE: 'lecture',
    FILE: 'file',
    FLASHCARD: 'flashcard',
    QBANK: 'qbank'
};

// Drag item structure
export const createDragItem = (type, id, index, data, scopeId = null) => ({
    type,
    id,
    index,
    data,
    scopeId,
    timestamp: Date.now()
});

// Drop target configuration
export const createDropTarget = (accept, onDrop, onHover = null) => ({
    accept,
    onDrop,
    onHover
});

// Reorder operation structure
export const createReorderOperation = (entityType, entityId, newPosition, scopeType = null, scopeId = null) => ({
    entityType,
    entityId,
    newPosition,
    scopeType,
    scopeId
});

// Transfer operation structure
export const createTransferOperation = (entityType, entityId, targetType, targetId) => ({
    entityType,
    entityId,
    targetType,
    targetId
});

// Bulk reorder operation structure
export const createBulkReorderOperation = (entityType, reorderData, scopeType = null, scopeId = null) => ({
    entityType,
    reorderData,
    scopeType,
    scopeId
});

// API endpoints
export const API_ENDPOINTS = {
    REORDER: '/admin/reorder',
    TRANSFER: '/admin/transfer',
    BULK_REORDER: '/admin/reorder/bulk',
    MOVE_TO_END: '/admin/reorder/move-to-end',
    MOVE_TO_BEGINNING: '/admin/reorder/move-to-beginning',
    FIX_GAPS: '/admin/reorder/fix-gaps',
    POSITION_STATS: '/admin/reorder/stats'
};

// DnD configuration
export const DND_CONFIG = {
    // Animation durations
    ANIMATION_DURATION: 300,
    
    // Visual feedback
    DRAGGING_OPACITY: 0.5,
    DRAGGING_ROTATION: 2,
    
    // Drop target styling
    DROP_TARGET_BORDER: '2px dashed',
    DROP_TARGET_BACKGROUND: 'rgba(1, 103, 126, 0.1)',
    
    // Drag handle styling
    DRAG_HANDLE_SIZE: 24,
    DRAG_HANDLE_COLOR: '#7f8c8d',
    DRAG_HANDLE_HOVER_COLOR: '#01677e'
};
